/**
 * Source Icons
 * Icons representing different load sources (DAT, Telegram, Parade, HappyRobot, TQL, ITF, PLS)
 */

import React, { useId } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/joy'

/**
 * DAT One Icon for DAT source loads
 */
export const DatOneIcon: React.FC<{ size?: number }> = ({ size = 32 }) => (
    <img
        src="/dat.jpg"
        alt="DAT"
        width={size}
        height={size}
        style={{ width: size, height: size, minWidth: size, minHeight: size, borderRadius: '4px', objectFit: 'contain', mixBlendMode: 'multiply' }}
    />
)

/**
 * Load source icon for load sources
 */
export const LoadSourceIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 25, height: 20 }} {...props}>
        <svg width="25" height="20" viewBox="0 0 25 20" fill="none">
            <path
                d="M12.4195 11.5408C12.4192 11.0703 12.2911 10.6084 12.0485 10.2031C11.8059 9.79774 11.4577 9.46363 11.0398 9.23538L8.09766 7.63077C7.67981 7.40252 7.33156 7.06841 7.08897 6.66306C6.84639 6.25772 6.71829 5.79587 6.71797 5.32538V0H0V3.31692C0 4.29231 0.546875 5.18769 1.42188 5.64461L4.27891 7.13692C4.70799 7.36151 5.06697 7.69675 5.31743 8.10677C5.56789 8.51679 5.7004 8.98615 5.70078 9.46461V19.5015H12.4195V11.5408ZM24.9984 16.5654C24.9984 15.5977 24.4594 14.7085 23.5953 14.2477L20.5656 12.6323C20.1418 12.406 19.7879 12.0714 19.5411 11.6636C19.2942 11.2558 19.1637 10.7901 19.1633 10.3154V0H12.4445V8.20769C12.4445 9.17461 12.9836 10.0638 13.8477 10.5246L16.8773 12.14C17.3012 12.3663 17.6551 12.7009 17.9019 13.1087C18.1487 13.5165 18.2792 13.9822 18.2797 14.4569V19.5015H24.9984V16.5654Z"
                fill="black"
            />
        </svg>
    </SvgIcon>
)

/**
 * Telegram icon for Telegram source loads (20x20)
 * From public/table-icons/Telegram.svg
 */
export const TelegramIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 20, height: 20 }} {...props}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 0C7.34844 0 4.80312 1.05422 2.92969 2.92891C1.05433 4.80435 0.000536638 7.34779 0 10C0 12.6511 1.05469 15.1964 2.92969 17.0711C4.80312 18.9458 7.34844 20 10 20C12.6516 20 15.1969 18.9458 17.0703 17.0711C18.9453 15.1964 20 12.6511 20 10C20 7.34891 18.9453 4.80359 17.0703 2.92891C15.1969 1.05422 12.6516 0 10 0Z"
                fill="url(#paint0_linear_telegram_table)"
            />
            <path
                d="M4.52658 9.89404C7.4422 8.62404 9.38595 7.78675 10.3578 7.38217C13.136 6.22701 13.7125 6.02639 14.0891 6.01959C14.1719 6.01826 14.3563 6.03873 14.4766 6.136C14.5766 6.21803 14.6047 6.32897 14.6188 6.40686C14.6313 6.48467 14.6485 6.66201 14.6344 6.80045C14.4844 8.3817 13.8328 12.2189 13.5016 13.99C13.3625 14.7394 13.086 14.9906 12.8188 15.0151C12.2375 15.0686 11.7969 14.6314 11.2344 14.2628C10.3547 13.6858 9.85783 13.3267 9.00314 12.7637C8.01564 12.1131 8.65626 11.7554 9.21876 11.1711C9.36564 11.0181 11.925 8.69076 11.9735 8.47967C11.9797 8.45326 11.986 8.35482 11.9266 8.30295C11.8688 8.25092 11.7828 8.26873 11.7203 8.28279C11.6313 8.30279 10.2266 9.23217 7.50158 11.0708C7.10314 11.3448 6.7422 11.4784 6.4172 11.4714C6.06095 11.4637 5.37345 11.2695 4.86251 11.1036C4.23751 10.9 3.73908 10.7923 3.78283 10.4465C3.8047 10.2665 4.05314 10.0823 4.52658 9.89404Z"
                fill="white"
            />
            <defs>
                <linearGradient id="paint0_linear_telegram_table" x1="1000" y1="0" x2="1000" y2="2000" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2AABEE" />
                    <stop offset="1" stopColor="#229ED9" />
                </linearGradient>
            </defs>
        </svg>
    </SvgIcon>
)

/**
 * Parade icon for Parade source loads (25x20)
 * From public/table-icons/Parade.svg
 */
export const ParadeIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 20, height: 20 }} {...props}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.85715 5.30477L8.09286 8.39049L12.2036 6.04191L6.97858 2.96191L2.85715 5.30477Z" fill="url(#paint0_linear_happyrobot_table)" />
            <path d="M8.0643 2.34286L13.2886 5.42214L17.4 3.07286L12.1857 0L8.0643 2.34286Z" fill="url(#paint1_linear_happyrobot_table)" />
            <path d="M13.48 12.1676L13.4757 6.08042L17.5757 3.73828L17.5807 9.78757L13.48 12.1676Z" fill="url(#paint2_linear_happyrobot_table)" />
            <path d="M8.29143 20L8.28714 9.04358L12.3871 6.70215L12.3914 17.6214L8.29143 20Z" fill="url(#paint3_linear_happyrobot_table)" />
            <defs>
                <linearGradient id="paint0_linear_happyrobot_table" x1="4.36858" y1="16.1105" x2="8.34" y2="2.99834" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1B84FF" />
                    <stop offset="0.51" stopColor="#007AFF" />
                    <stop offset="1" stopColor="#0053E1" />
                </linearGradient>
                <linearGradient id="paint1_linear_happyrobot_table" x1="8.31144" y1="17.3036" x2="12.2829" y2="4.19286" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1B84FF" />
                    <stop offset="0.51" stopColor="#007AFF" />
                    <stop offset="1" stopColor="#0053E1" />
                </linearGradient>
                <linearGradient id="paint2_linear_happyrobot_table" x1="12.3214" y1="18.519" x2="16.2929" y2="5.40828" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1B84FF" />
                    <stop offset="0.51" stopColor="#007AFF" />
                    <stop offset="1" stopColor="#0053E1" />
                </linearGradient>
                <linearGradient id="paint3_linear_happyrobot_table" x1="9.28285" y1="16.8171" x2="12.9929" y2="4.57072" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1B84FF" />
                    <stop offset="0.51" stopColor="#007AFF" />
                    <stop offset="1" stopColor="#0053E1" />
                </linearGradient>
            </defs>
        </svg>
    </SvgIcon>
)

/**
 * HappyRobot icon for HappyRobot source loads (20x20)
 * From public/table-icons/Happy Robot.svg
 */
export const HappyRobotIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{ width: 25, height: 20 }} {...props}>
        <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_parade_table)">
                <path
                    d="M12.4195 11.5408C12.4192 11.0703 12.2911 10.6084 12.0485 10.2031C11.8059 9.79774 11.4577 9.46363 11.0398 9.23538L8.09766 7.63077C7.67981 7.40252 7.33156 7.06841 7.08897 6.66306C6.84639 6.25772 6.71829 5.79587 6.71797 5.32538V0H0V3.31692C0 4.29231 0.546875 5.18769 1.42188 5.64461L4.27891 7.13692C4.70799 7.36151 5.06697 7.69675 5.31743 8.10677C5.56789 8.51679 5.7004 8.98615 5.70078 9.46461V19.5015H12.4195V11.5408ZM24.9984 16.5654C24.9984 15.5977 24.4594 14.7085 23.5953 14.2477L20.5656 12.6323C20.1418 12.406 19.7879 12.0714 19.5411 11.6636C19.2942 11.2558 19.1637 10.7901 19.1633 10.3154V0H12.4445V8.20769C12.4445 9.17462 12.9836 10.0638 13.8477 10.5246L16.8773 12.14C17.3012 12.3663 17.6551 12.7009 17.9019 13.1087C18.1487 13.5165 18.2792 13.9822 18.2797 14.4569V19.5015H24.9984V16.5654Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_parade_table">
                    <rect width="25" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

/**
 * TQL source icon (20x20) using tql.png
 */
export const TqlIcon: React.FC = () => <img src="/tql.png" alt="TQL" width={28} height={28} style={{ borderRadius: '4px', objectFit: 'contain' }} />

/**
 * ITF source icon (28x28) using itf.png
 */
export const ItfIcon: React.FC = () => <img src="/itf.png" alt="ITF" width={28} height={28} style={{ borderRadius: '4px', objectFit: 'contain' }} />

/**
 * PLS source icon (28x28) using pls.png
 */
export const PlsIcon: React.FC = () => <img src="/pls.png" alt="PLS" width={28} height={28} style={{ borderRadius: '4px', objectFit: 'contain' }} />

/**
 * BEON source icon (20x20) using beom.png
 */
export const BeonIcon: React.FC = () => <img src="/beom.png" alt="BEON" width={20} height={20} style={{ borderRadius: '4px' }} />

/**
 * Navisphere (C.H. Robinson) source icon (20x20) using robitson.jpg
 */
export const NavisphereIcon: React.FC = () => <img src="/robitson.jpg" alt="C.H. Robinson" width={20} height={20} style={{ borderRadius: '4px' }} />

/**
 * Arrive Logistics source icon (20x20) using arrive.png
 */
export const ArriveIcon: React.FC = () => <img src="/arrive.png" alt="Arrive Logistics" width={20} height={20} style={{ borderRadius: '4px' }} />

/**
 * SPOT source icon (20x20) using spot-logo.png
 */
export const SpotIcon: React.FC = () => <img src="/spot-logo.png" alt="SPOT" width={20} height={20} style={{ borderRadius: '4px', objectFit: 'contain' }} />

export const EmergeIcon: React.FC = () => <img src="/emerge.jpeg" alt="Emerge" width={20} height={20} style={{ borderRadius: '4px' }} />

/**
 * Echo (EchoDrive) source icon (20x20) using echo.png
 */
export const EchoIcon: React.FC = () => <img src="/echo_lb.webp" alt="Echo" width={32} height={32} style={{ borderRadius: '4px' }} />
export const RxoIcon: React.FC = () => <img src="/rxo_lb.png" alt="RXO" width={20} height={20} style={{ borderRadius: '4px', objectFit: 'contain' }} />
export const ModeGlobalIcon: React.FC = () => (
    <img src="/mode_globe.jpeg" alt="Mode Global" width={20} height={20} style={{ borderRadius: '4px', objectFit: 'contain' }} />
)

export const KnxIcon: React.FC = () => <img src="/knx_logo.png" alt="KNX" width={20} height={20} style={{ borderRadius: '4px' }} />

export const SchneiderIcon: React.FC = () => (
    <img src="/schneider_logo.webp" alt="Schneider" width={20} height={20} style={{ borderRadius: '4px', objectFit: 'contain' }} />
)

export const SylectusIcon: React.FC = () => (
    <img src="/sylectus.webp" alt="Sylectus" width={20} height={20} style={{ borderRadius: '4px', objectFit: 'contain' }} />
)

/**
 * Broker Outreach Icon — represents loads sourced from broker replies on the
 * broker-outreach-agent's cold-outreach threads. Teal chip signals "Numeo AI
 * channel" — sits in an open lane of the palette so it pops at a glance against
 * the blue-family loadboard chips (DAT, Truckstop) that dominate the SRC column.
 * Envelope glyph is preserved because these loads are genuinely email-derived.
 * Sized to match the visual weight of other branded source chips.
 */
export const BrokerOutreachIcon: React.FC<SvgIconProps> = (props) => {
    const gradId = useId()
    return (
        <SvgIcon {...props} viewBox="0 0 16 16" sx={{ width: 16, height: 16, ...props.sx }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                <defs>
                    <linearGradient id={gradId} x1="0" y1="0" x2="16" y2="16" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#0d9488" />
                        <stop offset="1" stopColor="#14b8a6" />
                    </linearGradient>
                </defs>
                <rect width="16" height="16" rx="3" fill={`url(#${gradId})`} />
                <rect x="3" y="5.25" width="10" height="6.5" rx="0.75" fill="#fff" />
                <path d="M3.5 5.9 L8 9 L12.5 5.9" stroke="#0d9488" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
        </SvgIcon>
    )
}

/**
 * Numeo Loads Icon — represents loads surfaced under Numeo's own first-party feed
 * (source = BROKER_PORTAL: broker-portal-published loads plus the Parade loads folded
 * in server-side). Uses the Numeo brand mark (the rounded blue app icon) so the source
 * reads unmistakably as "Numeo's own loads" rather than a third-party loadboard.
 * Rendered as an <img> (the wrapping picker cells already size svg AND img via their
 * `[&_img]` utilities); `size` from props.sx keeps the standalone sizing sensible.
 */
export const NumeoLoadsIcon: React.FC<SvgIconProps> = (props) => {
    const sx = (props.sx ?? {}) as { width?: number; height?: number }
    const size = typeof sx.width === 'number' ? sx.width : typeof sx.height === 'number' ? sx.height : 16
    return <img src="/logo-rounded.png" alt="Numeo Loads" width={size} height={size} style={{ borderRadius: '3px', objectFit: 'contain', display: 'block' }} />
}
